<template>
  <div class="editor-sidebar-main">
    <!-- 菜单区域 -->
    <div class="menu-content">
      <!--      <transition name="menu">-->
      <img class="select-bg-img" :style="selectActiveStyle" v-show="sidebarOption && showOption"
           src="https://files.wondercv.com/cv-sidebar/sidebar-select-bgimg.png" alt="">
      <!--      </transition>-->

      <!-- tab 检查 -->
      <div class="menu" :class="[sidebarOption === 'check' && !currentInfo.operation ? 'active' : 'not-select', (showResumeErrorGuide) ? 'guide-active' : '']"
           @mousedown.stop.prevent @mousemove.stop.prevent @click="selectActiveMenu('check')">
        <div class="menu-img">
          <img
              :src="sidebarOption === 'check' ? 'https://files.wondercv.com/cv-sidebar/check-1.png' : 'https://files.wondercv.com/cv-sidebar/check-not-select.png'"
              alt="">
        </div>
        <div class="menu-text">检查</div>
      </div>

      <!-- tab 职位 -->
      <div class="menu" :class="[sidebarOption === 'job' && !currentInfo.operation ? 'active' : 'not-select', (showJobGuide) ? 'guide-active' : '']"
           @mousedown.stop.prevent @mousemove.stop.prevent @click="selectActiveMenu('job')">
        <div class="menu-layer" v-if="(showJobGuide)"></div>
        <div class="menu-img">
          <img
              :src="(sidebarOption === 'job' || (showJobGuide) ) ? 'https://files.wondercv.com/cv-sidebar/job-1.png' : 'https://files.wondercv.com/cv-sidebars/job-not-select.png'"
              alt="">
        </div>
        <div class="menu-text">职位</div>
      </div>

      <!-- tab 经历库 -->
      <div class="menu" v-if="!isMentorEditor"
           :class="[sidebarOption === 'library' && !currentInfo.operation ? 'active' : 'not-select', (showLibraryGuide) ? 'guide-active' : '']"
           @mousedown.stop.prevent @mousemove.stop.prevent @click="selectActiveMenu('library')">
        <div class="menu-layer" v-if="(showLibraryGuide)"></div>
        <div class="menu-img">
          <img
              :src="(sidebarOption === 'library' ||  (showLibraryGuide)) ? 'https://files.wondercv.com/cv-sidebar/library-1.png' : 'https://files.wondercv.com/cv-sidebar/library-not-select.png'"
              alt="">
        </div>
        <div class="menu-text">经历库</div>
        <div class="update-library-tips" v-if="showUpdateLibrary">
          <span>一键导入已有经历，让简历制作更简单～</span>
          <div class="corner" />
        </div>
        <div class="tip" @click.stop v-if="false">
          <div class="tip-text">[ 简历库 ] 可以选择模块信息一键生成简历，简单高效快试试吧～</div>
          <div class="tip-btn">
            <button>我知道了</button>
            <button class="active">去试试</button>
          </div>
        </div>
      </div>

      <!-- tab 排版 -->
      <div class="menu" :class="[sidebarOption === 'composing' && !currentInfo.operation ? 'active' : 'not-select', (showComposingGuide) ? 'guide-active' : '']"
           @mousedown.stop.prevent @mousemove.stop.prevent @click="selectActiveMenu('composing')">
        <div class="menu-layer" v-if="(showComposingGuide)"></div>
        <div class="menu-img">
          <img
              :src="(sidebarOption === 'composing' || (showComposingGuide) ) ? 'https://files.wondercv.com/cv-sidebar/composing-1.png' : 'https://files.wondercv.com/cv-sidebar/composing-not-select.png'"
              alt="">
        </div>
        <div class="menu-text">排版</div>
      </div>

      <!-- tab 模块管理 -->
      <div class="menu" :class="[sidebarOption === 'manage' && !currentInfo.operation ? 'active' : 'not-select', (showManageGuide) ? 'guide-active' : '']"
           @mousedown.stop.prevent @mousemove.stop.prevent @click="selectActiveMenu('manage')">
        <div class="menu-layer" v-if="(showManageGuide)"></div>
        <div class="menu-img">
          <img
              :src="(sidebarOption === 'manage' || (showManageGuide) ) ? 'https://files.wondercv.com/cv-sidebar/manage-1.png' : 'https://files.wondercv.com/cv-sidebar/manage-not-select.png'"
              alt="">
        </div>
        <div class="menu-text">模块管理</div>
      </div>

    </div>
    <!-- 新用户引导 -->
    <!-- <div class="newUserGuide pa"
      :class="[showResumeErrorGuide ? 'resumeError' : '', showJobGuide ? 'job' : '', showComposingGuide ? 'composing' : '',showManageGuide ? 'manage' : '',showJobscanGuide ? 'jobscan' : '']"
      v-if="!cvDetail.basic_info.mentor_id && (showLibraryGuide || showJobGuide || showComposingGuide || showManageGuide || showJobscanGuide || showResumeErrorGuide)"
    >
      <img src="https://files.wondercv.com/pc/editor/sidebar/job.png" alt="" width="254" height="285" @click="addHideGuideState('hideJobState')" v-show="showJobGuide">
      <img src="https://files.wondercv.com/pc/editor/sidebar/library1.png" alt="" width="250" height="302" @click="addHideGuideState('hideLibraryState')" v-show="showLibraryGuide">
      <img src="https://files.wondercv.com/pc/editor/sidebar%3Acomposing-new2.png" alt="" width="250" height="303" @click="addHideGuideState('hideComposingState')" v-show="showComposingGuide">
      <img src="https://files.wondercv.com/pc/editor/sidebar/manage-new.png" alt="" width="250" height="302" @click="addHideGuideState('hideManageState')" v-show="showManageGuide">
      <img src="https://files.wondercv.com/pc/editor/sidebar/jobscan.png" alt="" width="309" height="77" @click="addHideGuideState('hideJobscanState')" v-show="showJobscanGuide">
      <img src="https://files.wondercv.com/pc/editor/sidebar/resume-error.png" alt="" width="248" height="256" @click="addHideGuideState('hideResumeErrorGuide')" v-show="showResumeErrorGuide">
    </div>
    <div class="layer"  v-if="!cvDetail.basic_info.mentor_id && !isMentorEditor && (!hideJobState || !hideLibraryState || !hideComposingState || !hideManageState || showJobscanGuide || showResumeErrorGuide)" @click="handleClickLayer"></div> -->

    <!-- 纠错模式下，功能不可用 -->
    <div class="open-resume-error-cover-up" v-show="openResumeError" @click.stop="showCloseResumeError()"></div>
  </div>
</template>
<script>
  import job from './job'
	import manage from './manage'
	import composing from './composing'
	import library from './library'
	import { mapState, mapMutations, mapGetters } from 'vuex'
  import { cvResumeErrorMixin } from '@/assets/js/mixins'

	export default {
		name: 'Sidebar',
		components: {
      job,
			manage,
			composing,
			library
		},
    mixins: [cvResumeErrorMixin],
		data () {
			return {
				option: [ {} ],
				// active: '', // 选中的选项卡
				isExperience: false, // 是否请求了经历
        hideJobState: true, //是否隐藏职位引导
				hideLibraryState: true, //是否隐藏经历库引导
				hideComposingState: true, //是否隐藏排版引导
				hideManageState: true, //是否隐藏模块管理引导
        hideJobscanState: true,//是否隐藏jobscan引导
        hideResumeErrorGuide: true, //是否隐藏检查-简历纠错引导
				showOption: true,
        showUpdateLibraryState: true,   // 新建简历经历库引导显示开关
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvInfo', 'edidModuleData' ]),
			...mapState('editor', [ 'cvToken', 'currentInfo', 'openSidebarModule', 'isShowJobscanGuide', 'score', 'cvDetail', 'hasJobscanRepor', 'openResumeError', ]),
			...mapGetters('experience', [ 'experienceListLength' ]),
			...mapState('experience', [ 'sidebarOption', 'currentExperienceType', 'backUpExperienceList', 'experienceList']),
			isMentorEditor () {
				return window.location.href.includes('mentor')
			},
			selectActiveStyle () {
				let option = [ 'check', 'job', 'library', 'composing', 'manage' ]
				const index = option.findIndex(item => item === this.sidebarOption)
        // 这些 tab 中，只有简历库有显示和隐藏的状态，其他 tab 会一直常驻（经历库修改为常驻）
        // 有简历库时 计算的 dom:select-bg-img 的 top 值
				if (index > -1 && this.experienceListLength && !this.isMentorEditor) {
					return {
						transform: `translateY(${ index * 106 }px)`
					}
        // 没有简历库时 简历库后面的 tab 计算时 index 都需要减 1
				} else if (index > -1) {
          let replaceIndex = null
          if(index === 1) {
            replaceIndex = index
          } else {
            // replaceIndex = !index ? index : index - 1
            replaceIndex = !index ? index : index
          }
					return {
						transform: `translateY(${ replaceIndex * 106 }px)`
					}
				} else {
					return {}
				}
			},
      // // 经历库是否有经历
      // libraryIsLength() {
      //   let isLength = false
      //   let extras = this.experienceList.extras
      //   for (let key in this.experienceList) {
      //     if (key !== 'extras' && this.experienceList[key].length) {
      //       isLength = true
      //     }
      //   }
      //   for (let key in extras) {
      //     if (extras[key].length) {
      //       isLength = true
      //     }
      //   }
      //   return isLength
      // },
      // showUpdateLibrary() {
      //   return !this.showResumeErrorGuide && !this.showJobscanGuide && !this.showLibraryGuide && !this.showComposingGuide && !this.showManageGuide && this.cvDetail.basic_info.kind && this.showUpdateLibraryState && this.libraryIsLength
      // },
      // showResumeErrorGuide(){ // 检查-简历纠错引导条件
      //   // let isShow = !this.isMentorEditor && this.hideJobState && this.hideLibraryState && this.hideComposingState && this.hideManageState && !this.hideJobscanState && !this.hideResumeErrorGuide && this.cvDetail.basic_info.lang != 'en'
      //   return !this.isMentorEditor && !this.hideResumeErrorGuide && this.cvDetail.basic_info.lang === 'cn'
      // },
      // showJobGuide() {//显示职位引导条件
			//   return !this.isMentorEditor && !this.showResumeErrorGuide && !this.hideJobState && !this.cvDetail.basic_info.mentor_id
      // },
      // showLibraryGuide() {//显示经历库引导条件
			//   return !this.isMentorEditor && !this.showResumeErrorGuide  && this.hideJobState && !this.hideLibraryState && !this.cvDetail.basic_info.mentor_id
      // },
      // showComposingGuide() {//显示排版引导条件
      //   return !this.isMentorEditor && !this.showResumeErrorGuide  && this.hideJobState && this.hideLibraryState && !this.hideComposingState && !this.cvDetail.basic_info.mentor_id
      // },
      // showManageGuide() {//显示模块引导条件
      //   return !this.isMentorEditor && !this.showResumeErrorGuide  && this.hideJobState && this.hideLibraryState && this.hideComposingState && !this.hideManageState && !this.cvDetail.basic_info.mentor_id
      // },
      // showJobscanGuide() {//显示jobscan引导条件
      //   return !this.hasJobscanRepor && !this.isMentorEditor && !this.showResumeErrorGuide  && this.hideJobState && this.hideLibraryState && this.hideComposingState && this.hideManageState && !this.hideJobscanState && this.score > 60 && this.cvDetail.basic_info.lang != 'en' && !this.currentInfo.operation && !this.cvDetail.basic_info.mentor_id && this.sidebarOption === 'check'
      // },
		},
		created () {
      // this.hideJobState = !!localStorage.getItem('hideJobState')
			// this.hideLibraryState = !!localStorage.getItem('hideLibraryState')
			// this.hideComposingState = !!localStorage.getItem('hideComposingState')
      // this.hideManageState = !!localStorage.getItem('hideManageState')
      // this.hideJobscanState = !!localStorage.getItem('hideJobscanState')
      // this.hideResumeErrorGuide = !!localStorage.getItem('hideResumeErrorGuide')
		},
		watch: {
      showUpdateLibrary: {
        handler(val) {
          if (val) {
            setTimeout(() => {
              this.showUpdateLibraryState = false
            },3000)
          }
        }
      },
			// experienceListLength: function (state) { //监听是否有经历库数据
			// 	//没有经历&&当前是经历库打开模式，关闭经历库tab
			// 	if (!state && this.sidebarOption === 'library') {
			// 		setTimeout(() => {
			// 			this.updateSidebarOption('')
			// 		}, 100)
			// 	}
			// },
			openSidebarModule: { //检测是否直接打开tab
				handler (newData, oldData) {
					if (newData.state && newData.type) {
						this.selectActiveMenu(newData.type)
					}
				},
				immediate: true,
				deep: true
			},
      score(val){
        if(this.hideJobState && this.hideLibraryState && this.hideComposingState && this.hideManageState && !this.hideJobscanState && this.score > 60 && this.cvDetail.basic_info.lang != 'en' && !this.currentInfo.operation && this.sidebarOption === 'check'){
          this.setIsShowJobscanGuide(true)
        }
      },
      isShowJobscanGuide(value){
			  if(!value){
			    this.addHideGuideState('hideJobscanState')
        }
      },
      'currentInfo.operation'(value){
			  if(!value){
          if(this.hideJobState && this.hideLibraryState && this.hideComposingState && this.hideManageState && !this.hideJobscanState && this.score > 60 && this.cvDetail.basic_info.lang != 'en' && this.sidebarOption === 'check'){
            this.setIsShowJobscanGuide(true)
          }
        }
      }
		},
		methods: {
			...mapMutations('experience', [ 'updateSidebarOption', 'updateExperienceList' ]),
			...mapMutations('editor', [ 'setCheckCloseEditModule', 'setOpenSidebarModule', 'setIsShowJobscanGuide' ]),
			selectActiveMenu (active) {
        // 点击切换不是经历库的 tab 时更新经历库数据
        if (active !== 'library') {
          //把备份数据同步到当前经历库数据中
          this.updateExperienceList(JSON.parse(JSON.stringify(this.backUpExperienceList)))
        }
			  if(this.showJobGuide || this.showLibraryGuide || this.showComposingGuide || this.showManageGuide){
			    return
        }
				if (this.currentInfo.operation) {
					//设置是否需要取消当前编辑状态，并返回
					this.setCheckCloseEditModule(true)
					//重置要打开的内容
					this.setOpenSidebarModule({
						state: false,
						type: active
					})
				}
				// this.showOption = false
				//增加延迟，防止watch时不生效
				setTimeout(() => {
					if (this.currentInfo.operation) {
						// this.$message.warning('没有基本信息经历');
						// this.$message.warning('请先保存当前模块信息');
						return false
					}
					//重置要打开的内容
					this.setOpenSidebarModule({
						state: false,
						type: ''
					})
					this.updateSidebarOption(active)

              this.addHideGuideState('hideJobState')
					// if (this.sidebarOption === 'library') {
					// 	//把重置经历库数据
					// 	this.updateExperienceList(this.backUpExperienceList)
					// 	//如果跳过引导，直接打开经历库，关闭引导
					// 	if (!this.hideLibraryState) {
							this.addHideGuideState('hideLibraryState')
					// 	}
					// }
					// if (this.sidebarOption === 'composing') {
					// 	//如果跳过引导，直接打开经历库，关闭引导
					// 	if (!this.hideComposingState) {
							this.addHideGuideState('hideComposingState')
					// 	}
					// }
					// if (this.sidebarOption === 'manage') {
					// 	//如果跳过引导，直接打开经历库，关闭引导
					// 	if (!this.hideManageState) {
							this.addHideGuideState('hideManageState')
					// 	}
					// }
          this.addHideGuideState('hideResumeErrorGuide')
					//更新当前打开tab
					// this.updateSidebarOption(this.sidebarOption === active ? '' : active)
					this.showOption = true
				}, 100)
			},
      //增加已经打开过经历库状态
      addHideGuideState (type) {
        localStorage.setItem(type, true)
        this[type] = true
        if(type === 'hideResumeErrorGuide'){
          this.hideResumeErrorGuide = true
        }
        if(type === 'hideManageState' && this.cvDetail.basic_info.lang != 'en'){
          if(this.score > 60 && !this.hideJobscanState){
            this.setIsShowJobscanGuide(true)
          }
        }else if(type === 'hideJobscanState'){
          this.setIsShowJobscanGuide(false)
        }
      },
      //点击引导遮罩层
      handleClickLayer(){
        // 集合处理关闭
        let hideList = {
          showJobGuide: 'hideJobState',
          showLibraryGuide: 'hideLibraryState',
          showComposingGuide: 'hideComposingState',
          showManageGuide: 'hideManageState',
          showJobscanGuide: 'hideJobscanState',
          showResumeErrorGuide: 'hideResumeErrorGuide',
        }
        let hideType = '';
        Object.keys(hideList).forEach(key => {
          if(this[key] && !hideType){
            hideType = hideList[key]
          }
        })
        if(!!hideType){
          this.addHideGuideState(hideType)
        }
      }
			// 打开经历库
			// toLibrary(){
			//   this.addHideGuideState('hideLibraryState');
			//   this.selectActiveMenu('library');
			// },
		},
	}
</script>
<style lang="scss" scoped>
  // 公共初始化样式 
  @import '~/assets/css/public';
  @import 'index';
  .layer{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0,0,0,0.6);
  }
  .guide-active{
    position: relative;
    z-index: 11;
    background-color: #353944;
    border-radius: 8px;
    margin-bottom: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
    color: #FF6644;
    .menu-img{
      background-color: #fff !important;
    }
    &:hover .menu-text{
      font-weight: 400 !important;
    }
    &.active{
      background: none;
    }
  }
</style>
